import type { Theme } from '@mui/material';

/**
 * Builds marker / info-window DOM directly instead of `renderToString`
 * (react-dom/server). The content is trivial markup, and `renderToString` was
 * running for every pin on every render of the map view — an expensive hot
 * path. Using `textContent` here also avoids any HTML-injection from pin data.
 */

export const createPinMarkerContent = (color: string, theme: Theme): HTMLElement => {
  const container = document.createElement('div');
  container.style.width = '32px';
  container.style.height = '32px';

  const dot = document.createElement('div');
  dot.style.cssText = [
    'width: 24px',
    'height: 24px',
    `background-color: ${theme.palette.SlabGray[0]}`,
    'border-radius: 50%',
    `border: 4px solid ${color}`,
    'box-sizing: border-box',
  ].join(';');

  container.appendChild(dot);
  return container;
};

export const createPinInfoContent = (name: string, address: string): HTMLElement => {
  const root = document.createElement('div');

  const title = document.createElement('strong');
  title.textContent = name;

  const subtitle = document.createElement('small');
  subtitle.textContent = address;

  root.append(title, document.createElement('br'), subtitle);
  return root;
};
